var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinBold = function SvgPinBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pin-bold_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pin-bold_svg__st0{stroke:#000;stroke-width:.5;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pin-bold_svg__st0",
    d: "M24 34c-.1 0-.3-.1-.4-.2-.1-.1-1.4-1.8-2.8-4.4-.8-1.5-1.5-3-1.9-4.4-.6-1.8-.9-3.5-.9-5 0-3.3 2.7-6 6-6s6 2.7 6 6c0 1.5-.3 3.2-.9 5-.5 1.4-1.1 2.9-1.9 4.4-1.4 2.6-2.8 4.3-2.8 4.4-.1.1-.3.2-.4.2zm0-19c-2.8 0-5 2.2-5 5 0 3.3 1.5 6.6 2.7 8.9.9 1.7 1.8 3 2.3 3.7.5-.7 1.4-2 2.3-3.7 1.2-2.3 2.7-5.7 2.7-8.9 0-2.8-2.2-5-5-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pin-bold_svg__st0",
    d: "M24 23c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  })));
};
export default SvgPinBold;